import React from "react";
import stripeLogo from "../images/landing-page/new/stripe.png";
import googleLogo from "../images/landing-page/new/Google.png";
import cleverLogo from "../images/landing-page/new/Clever.png";
import "../styles/solutions-page.css";

const INTEGRATIONS = [
    { src: stripeLogo, alt: "Stripe" },
    { src: googleLogo, alt: "Google" },
    { src: cleverLogo, alt: "Clever" },
];

export default function IntegrationsBar() {
    return (
        <section className="solution-integrations" aria-label="Integrations">
            <div className="solution-integrations-bar">
                <span className="solution-integrations-label">Integrations</span>
                <div className="solution-integrations-logos">
                    {INTEGRATIONS.map(({ src, alt }) => (
                        <img key={alt} src={src} alt={alt} className="solution-integrations-logo" />
                    ))}
                </div>
            </div>
        </section>
    );
}
